(() => {
  const qs = (s, root = document) => root.querySelector(s);
  const qsa = (s, root = document) => [...root.querySelectorAll(s)];
  const drawer = qs('[data-cart-drawer]');
  const cartContent = qs('[data-cart-content]');
  const cartCount = qs('[data-cart-count]');
  const cartPage = qs('[data-cart-page]');
  const mobileHaptic = () => { if (window.matchMedia && window.matchMedia('(max-width: 800px)').matches && typeof navigator.vibrate === 'function') navigator.vibrate(18); };

  const money = (cents) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-AE', { style: 'currency', currency: 'AED', maximumFractionDigits: 0 }).format(cents / 100); }
    catch (e) { return `AED ${(cents / 100).toFixed(0)}`; }
  };

  const openCart = () => { window.location.assign((window.routes && window.routes.cart) || '/cart'); };
  const closeCart = () => { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('no-scroll'); };
  const refreshCart = async () => {
    if (!cartContent) return;
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      if (cartCount) { cartCount.textContent = cart.item_count; cartCount.classList.toggle('is-empty', cart.item_count < 1); cartCount.setAttribute('aria-label', `${cart.item_count} items in cart`); }
      if (!cart.item_count) { cartContent.innerHTML = '<div class="cart-empty cart-drawer__empty"><div class="cart-empty__icon">🛒</div><p>Your cart is currently empty.</p><a class="button button--primary" href="/collections/all">Start shopping</a></div>'; return; }
      const drawerItems = cart.items.map(item => `<article class="cart-drawer__item"><a class="cart-drawer__media" href="${item.url}"><img class="cart-drawer__image" src="${item.image || ''}" alt="${escapeHtml(item.product_title || item.title)}"></a><div class="cart-drawer__details"><a class="cart-drawer__title" href="${item.url}">${escapeHtml(item.product_title || item.title)}</a>${item.variant_title && item.variant_title !== 'Default Title' ? `<span class="cart-drawer__variant">${escapeHtml(item.variant_title)}</span>` : ''}<span class="cart-drawer__unit">${money(item.final_price)} each</span><div class="cart-drawer__controls"><label>Qty <input type="number" min="0" value="${item.quantity}" data-drawer-quantity data-line-key="${item.key}" aria-label="Quantity for ${escapeHtml(item.product_title || item.title)}"></label><button class="cart-drawer__remove" type="button" data-remove-line data-line-key="${item.key}">Remove</button></div></div><strong class="cart-drawer__price">${money(item.final_line_price)}</strong></article>`).join('');
      cartContent.innerHTML = `<div class="cart-drawer__items">${drawerItems}</div><div class="cart-drawer__summary"><div class="cart-drawer__summary-row"><span>Subtotal</span><strong>${money(cart.total_price)}</strong></div><p class="cart-drawer__note">Shipping and any applicable taxes are calculated at checkout.</p><a class="button button--primary cart-drawer__checkout" href="/checkout">Proceed to checkout →</a><a class="button button--secondary cart-drawer__view-cart" href="/cart">View full cart</a><div class="cart-drawer__trust"><span>✓</span><div><strong>Secure checkout</strong><small>Dubai &amp; UAE delivery · Cash on Delivery available</small></div></div></div>`;
      qsa('[data-remove-line]').forEach(btn => btn.addEventListener('click', () => updateLine(btn.dataset.lineKey, 0)));
      qsa('[data-drawer-quantity]').forEach(input => input.addEventListener('change', () => updateLine(input.dataset.lineKey, Math.max(0, Number(input.value) || 0))));
    } catch (error) { cartContent.innerHTML = '<p>Unable to load the cart. Please open the cart page.</p><a class="button button--primary" href="/cart">Open cart</a>'; }
  };
  const updateLine = async (key, quantity) => { await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) }); refreshCart(); };
  const setCartQuantityBusy = (control, busy, message = '') => {
    if (!control) return;
    control.classList.toggle('is-updating', busy);
    control.setAttribute('aria-busy', busy ? 'true' : 'false');
    const status = qs('[data-cart-quantity-status]', control);
    if (status) status.textContent = message;
  };
  const cartLineUpdateStates = new Map();
  const syncCartPageTotals = cart => {
    if (!cartPage || !cart) return;
    if (cartCount) { cartCount.textContent = cart.item_count; cartCount.classList.toggle('is-empty', cart.item_count < 1); cartCount.setAttribute('aria-label', `${cart.item_count} items in cart`); }
    const countLabel = qs('[data-cart-count-label]', cartPage);
    if (countLabel) countLabel.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`;
    const cartTotal = qs('[data-cart-total]', cartPage);
    if (cartTotal) cartTotal.textContent = money(cart.total_price);
  };
  const showOptimisticCartTotals = () => {
    if (!cartPage) return;
    let totalCents = 0;
    let itemCount = 0;
    qsa('[data-cart-quantity-control]', cartPage).forEach(control => {
      const line = control.closest('.cart-page__line');
      const input = qs('[data-cart-quantity-input]', control);
      const linePrice = qs('.cart-page__line-price', line);
      const quantity = Math.max(1, Math.floor(Number(input?.value) || 1));
      const unitCents = Math.max(0, Number(line?.dataset.cartUnitPriceCents || 0));
      const lineTotal = unitCents * quantity;
      itemCount += quantity;
      totalCents += lineTotal;
      if (linePrice) linePrice.textContent = money(lineTotal);
    });
    if (cartCount) { cartCount.textContent = itemCount; cartCount.classList.toggle('is-empty', itemCount < 1); cartCount.setAttribute('aria-label', `${itemCount} items in cart`); }
    const countLabel = qs('[data-cart-count-label]', cartPage);
    if (countLabel) countLabel.textContent = `${itemCount} ${itemCount === 1 ? 'item' : 'items'}`;
    const cartTotal = qs('[data-cart-total]', cartPage);
    if (cartTotal) cartTotal.textContent = money(totalCents);
  };
  const updateCartPageLine = (control, quantity) => {
    if (!control || !cartPage) return;
    const key = control.dataset.cartLineKey || qs('[data-cart-quantity-input]', control)?.dataset.cartLineKey;
    if (!key) return;
    const input = qs('[data-cart-quantity-input]', control);
    const nextQuantity = Math.max(1, Math.floor(Number(quantity) || 1));
    if (input) input.value = String(nextQuantity);
    showOptimisticCartTotals();
    const existing = cartLineUpdateStates.get(key) || { timer: null, inFlight: false, desiredQuantity: nextQuantity, control };
    existing.desiredQuantity = nextQuantity;
    existing.control = control;
    cartLineUpdateStates.set(key, existing);
    if (existing.timer || existing.inFlight) return;
    existing.timer = window.setTimeout(async () => {
      existing.timer = null;
      if (existing.inFlight) return;
      const requestedQuantity = existing.desiredQuantity;
      existing.inFlight = true;
      setCartQuantityBusy(control, true, 'Updating quantity…');
      try {
        const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: requestedQuantity }) });
        if (!response.ok) throw new Error('Cart update failed');
        const cart = await response.json();
        const line = cart.items.find(item => item.key === key);
        if (existing.desiredQuantity !== requestedQuantity) {
          existing.inFlight = false;
          setCartQuantityBusy(control, false);
          updateCartPageLine(existing.control, existing.desiredQuantity);
          return;
        }
        const lineElement = control.closest('.cart-page__line');
        if (line && lineElement) {
          if (input) input.value = String(line.quantity);
          const linePrice = qs('.cart-page__line-price', lineElement);
          if (linePrice) linePrice.textContent = money(line.final_line_price);
        }
        syncCartPageTotals(cart);
        existing.inFlight = false;
        setCartQuantityBusy(control, false, 'Quantity updated');
        window.setTimeout(() => { if (!existing.inFlight) setCartQuantityBusy(control, false, ''); }, 700);
      } catch (error) {
        existing.inFlight = false;
        if (existing.desiredQuantity !== requestedQuantity) {
          setCartQuantityBusy(control, false);
          updateCartPageLine(existing.control, existing.desiredQuantity);
          return;
        }
        setCartQuantityBusy(control, false, 'Unable to update quantity');
        if (input) input.value = String(requestedQuantity);
        showOptimisticCartTotals();
      }
    }, 30);
  };
  const escapeHtml = (value) => String(value).replace(/[&<>'"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[c]));

  /* Shopify predictive product search */
  const searchForm = qs('[data-search-form]');
  const searchInput = qs('[data-search-input]');
  const searchSuggestions = qs('[data-search-suggestions]');
  if (searchForm && searchInput && searchSuggestions) {
    let searchTimer;
    let searchController;
    const closeSearchSuggestions = () => { searchSuggestions.hidden = true; searchSuggestions.innerHTML = ''; searchInput.setAttribute('aria-expanded', 'false'); };
    const showSearchSuggestions = (products, query) => {
      if (!products.length) { searchSuggestions.innerHTML = `<div class="search-suggestions__empty">No products found for “${escapeHtml(query)}”</div>`; searchSuggestions.hidden = false; searchInput.setAttribute('aria-expanded', 'true'); return; }
      searchSuggestions.innerHTML = products.map(product => { const image = product.featured_image && product.featured_image.url || product.image || ''; const url = product.url || `/products/${encodeURIComponent(product.handle || '')}`; return `<a class="search-suggestion" href="${url}" role="option"><span class="search-suggestion__image">${image ? `<img src="${image}" alt="" loading="lazy">` : ''}</span><span class="search-suggestion__title">${escapeHtml(product.title)}</span><span class="search-suggestion__arrow">→</span></a>`; }).join('');
      searchSuggestions.hidden = false;
      searchInput.setAttribute('aria-expanded', 'true');
    };
    const loadSearchSuggestions = async () => {
      const query = searchInput.value.trim();
      if (query.length < 2) { closeSearchSuggestions(); return; }
      if (searchController) searchController.abort();
      searchController = new AbortController();
      try {
        const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide`, { headers: { Accept: 'application/json' }, signal: searchController.signal });
        if (!response.ok) throw new Error('predictive search failed');
        const data = await response.json();
        const products = data.resources && data.resources.results && data.resources.results.products || [];
        if (searchInput.value.trim() === query) showSearchSuggestions(products, query);
      } catch (error) { if (error.name !== 'AbortError') closeSearchSuggestions(); }
    };
    const isMobileSearch = () => window.matchMedia && window.matchMedia('(max-width: 800px)').matches;
    const openMobileSearch = () => {
      searchForm.classList.add('is-mobile-open');
      searchForm.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame?.(() => searchInput.focus({ preventScroll: true }));
    };
    const closeMobileSearch = () => { searchForm.classList.remove('is-mobile-open'); searchForm.setAttribute('aria-expanded', 'false'); };
    searchInput.addEventListener('input', () => { clearTimeout(searchTimer); searchTimer = setTimeout(loadSearchSuggestions, 180); });
    searchInput.addEventListener('focus', () => { if (searchInput.value.trim().length >= 2) loadSearchSuggestions(); });
    searchInput.addEventListener('keydown', event => { if (event.key === 'Escape') { closeSearchSuggestions(); closeMobileSearch(); } if (event.key === 'ArrowDown' && !searchSuggestions.hidden) { event.preventDefault(); const first = qs('.search-suggestion', searchSuggestions); if (first) first.focus(); } });
    const searchTrigger = qs('button[type="submit"]', searchForm);
    searchTrigger?.addEventListener('click', event => { if (isMobileSearch() && !searchForm.classList.contains('is-mobile-open')) { event.preventDefault(); mobileHaptic(); openMobileSearch(); } });
    searchForm.addEventListener('submit', event => { if (isMobileSearch() && !searchForm.classList.contains('is-mobile-open')) { event.preventDefault(); openMobileSearch(); return; } closeSearchSuggestions(); closeMobileSearch(); });
    document.addEventListener('click', event => { if (!searchForm.contains(event.target)) { closeSearchSuggestions(); closeMobileSearch(); } });
  }

  qsa('[data-cart-open]').forEach(el => el.addEventListener('click', event => { event.preventDefault(); window.location.assign('/cart'); }));
  qsa('.header-icon-link[aria-label="Wishlist"], [data-wishlist-open]').forEach(el => el.addEventListener('click', mobileHaptic));
  qsa('[data-cart-close]').forEach(el => el.addEventListener('click', event => { event.preventDefault(); closeCart(); }));
  document.addEventListener('click', event => { if (event.target.closest('[data-cart-close]')) { event.preventDefault(); closeCart(); } });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') { closeCart(); closeVideo(); } });

  qsa('[data-product-form]').forEach(form => form.addEventListener('submit', async event => {
    mobileHaptic();
    event.preventDefault();
    const button = qs('[data-add-to-cart]', form); const original = button ? button.innerHTML : '';
    if (button) { button.disabled = true; button.innerHTML = 'Adding…'; }
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('add failed');
      if (button) {
        button.classList.add('is-cart-adding');
        button.setAttribute('aria-busy', 'true');
        button.innerHTML = '<span class="add-to-cart-status-icon" aria-hidden="true">✓</span><span>Added to cart</span>';
      }
      if (cartCount) {
        cartCount.classList.remove('cart-count-pop');
        void cartCount.offsetWidth;
        cartCount.classList.add('cart-count-pop');
      }
      mobileHaptic();
      window.setTimeout(() => {
        if (button) {
          button.classList.remove('is-cart-adding');
          button.removeAttribute('aria-busy');
          button.innerHTML = original;
          button.disabled = false;
        }
        openCart();
      }, 520);
    } catch (error) { form.submit(); }
  }));

  const wishlistKey = 'pakplus-wishlist';
  const getWishlist = () => { try { return JSON.parse(localStorage.getItem(wishlistKey) || '[]'); } catch (e) { return []; } };
  const saveWishlist = list => localStorage.setItem(wishlistKey, JSON.stringify(list));
  const syncWishlist = () => qsa('[data-wishlist]').forEach(btn => { const active = getWishlist().includes(btn.dataset.productHandle); btn.classList.toggle('is-active', active); btn.setAttribute('aria-pressed', active ? 'true' : 'false'); });
  qsa('[data-wishlist]').forEach(btn => btn.addEventListener('click', () => {
    mobileHaptic();
    const list = getWishlist();
    const index = list.indexOf(btn.dataset.productHandle);
    if (index >= 0) list.splice(index, 1); else list.push(btn.dataset.productHandle);
    saveWishlist(list);
    syncWishlist();
    btn.classList.remove('wishlist-clicked');
    void btn.offsetWidth;
    btn.classList.add('wishlist-clicked');
  }));
  qsa('[data-wishlist-open]').forEach(btn => btn.addEventListener('click', () => { window.location.href = '/search?view=wishlist'; }));

  const wishlistPage = qs('[data-wishlist-page]');
  if (wishlistPage) {
    const wishlistItems = qs('[data-wishlist-items]', wishlistPage);
    const wishlistEmpty = qs('[data-wishlist-empty]', wishlistPage);
    const wishlistLoading = qs('[data-wishlist-loading]', wishlistPage);
    const renderWishlist = async () => {
      const handles = getWishlist();
      if (!handles.length) { if (wishlistItems) wishlistItems.innerHTML = ''; if (wishlistLoading) wishlistLoading.hidden = true; if (wishlistEmpty) wishlistEmpty.hidden = false; return; }
      const products = (await Promise.all(handles.map(async handle => { try { const response = await fetch(`/products/${encodeURIComponent(handle)}.js`); return response.ok ? response.json() : null; } catch (error) { return null; } }))).filter(Boolean);
      if (wishlistLoading) wishlistLoading.hidden = true;
      if (!products.length) { if (wishlistItems) wishlistItems.innerHTML = ''; if (wishlistEmpty) wishlistEmpty.hidden = false; return; }
      if (wishlistItems) wishlistItems.innerHTML = products.map(product => { const variant = product.variants && product.variants.find(item => item.available) || product.variants && product.variants[0]; const image = product.featured_image || product.images && product.images[0] || ''; const price = (Number(product.price || 0) / 100).toLocaleString('en-AE', { maximumFractionDigits: 0 }); return `<article class="wishlist-card" data-wishlist-card data-product-handle="${escapeHtml(product.handle)}"><a class="wishlist-card__media" href="${product.url || `/products/${encodeURIComponent(product.handle)}`}" aria-label="View ${escapeHtml(product.title)}">${image ? `<img src="${image}" alt="${escapeHtml(product.title)}" loading="lazy">` : `<span>${escapeHtml(product.title.slice(0, 1))}</span>`}</a><div class="wishlist-card__body"><h2><a href="${product.url || `/products/${encodeURIComponent(product.handle)}`}">${escapeHtml(product.title)}</a></h2><strong class="price">AED ${price}</strong><div class="wishlist-card__actions"><a class="button button--primary" href="${product.url || `/products/${encodeURIComponent(product.handle)}`}">View Product</a><button class="button button--secondary" type="button" data-wishlist-remove data-product-handle="${escapeHtml(product.handle)}">Remove</button></div></div></article>`; }).join('');
      qsa('[data-wishlist-remove]', wishlistPage).forEach(button => button.addEventListener('click', () => { saveWishlist(getWishlist().filter(handle => handle !== button.dataset.productHandle)); renderWishlist(); }));
    };
    renderWishlist();
  }
  syncWishlist();

  const mobileMenu = qs('[data-mobile-menu]');
  const positionMobileMenu = () => {
    if (!mobileMenu) return;
    const stickyHeader = qs('.header-group-sticky');
    const headerBottom = stickyHeader ? Math.max(0, Math.round(stickyHeader.getBoundingClientRect().bottom)) : 0;
    mobileMenu.style.setProperty('--mobile-menu-top', `${headerBottom}px`);
  };
  const setMenu = open => { if (!mobileMenu) return; if (open) positionMobileMenu(); mobileMenu.classList.toggle('is-open', open); mobileMenu.setAttribute('aria-hidden', open ? 'false' : 'true'); document.body.classList.toggle('no-scroll', open); const toggle = qs('[data-mobile-menu-toggle]'); if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false'); };
  window.addEventListener('resize', () => { if (mobileMenu && mobileMenu.classList.contains('is-open')) positionMobileMenu(); });
  qsa('[data-mobile-menu-toggle]').forEach(btn => btn.addEventListener('click', () => { mobileHaptic(); setMenu(!mobileMenu.classList.contains('is-open')); }));
  qsa('[data-mobile-menu-close]').forEach(btn => btn.addEventListener('click', () => setMenu(false)));
  qsa('[data-mobile-menu] a').forEach(link => link.addEventListener('click', () => setMenu(false)));

  const videoModal = qs('[data-video-modal]');
  const openVideo = () => { if (!videoModal) return; videoModal.classList.add('is-open'); videoModal.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll'); };
  function closeVideo() { if (!videoModal) return; videoModal.classList.remove('is-open'); videoModal.setAttribute('aria-hidden', 'true'); document.body.classList.remove('no-scroll'); }
  qsa('[data-video-open]').forEach(btn => btn.addEventListener('click', openVideo));
  qsa('[data-video-close]').forEach(btn => btn.addEventListener('click', closeVideo));

  // Product page: gallery, variants, quantity, tabs and purchase actions.
  const setGalleryMedia = thumb => {
    if (!thumb) return;
    const mediaId = thumb.dataset.mediaThumb;
    qsa('[data-media-thumb]').forEach(item => item.classList.toggle('is-active', item === thumb));
    qsa('[data-media-slide]').forEach(slide => slide.classList.toggle('is-active', slide.dataset.mediaSlide === mediaId));
  };
  qsa('[data-media-thumb]').forEach(thumb => thumb.addEventListener('click', () => setGalleryMedia(thumb)));
  const moveGallery = direction => {
    const thumbs = qsa('[data-media-thumb]');
    if (thumbs.length < 2) return;
    const activeIndex = Math.max(0, thumbs.findIndex(thumb => thumb.classList.contains('is-active')));
    const nextIndex = (activeIndex + direction + thumbs.length) % thumbs.length;
    setGalleryMedia(thumbs[nextIndex]);
  };
  qsa('[data-gallery-prev]').forEach(button => button.addEventListener('click', () => moveGallery(-1)));
  qsa('[data-gallery-next]').forEach(button => button.addEventListener('click', () => moveGallery(1)));
  const galleryMain = qs('[data-gallery-main]');
  if (galleryMain) {
    let touchStartX = 0;
    let touchStartY = 0;
    galleryMain.addEventListener('touchstart', event => {
      if (event.target.closest('.product-gallery__video')) return;
      const touch = event.changedTouches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    }, { passive: true });
    galleryMain.addEventListener('touchend', event => {
      if (event.target.closest('.product-gallery__video')) return;
      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;
      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      moveGallery(deltaX < 0 ? 1 : -1);
    }, { passive: true });
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!button) return;
    event.preventDefault();
    const cartControl = button.closest('[data-cart-quantity-control]');
    const scope = button.closest('[data-product-purchase-form]') || cartControl || document;
    const input = qs('[data-quantity-input]', scope);
    if (!input) return;
    const min = Number.isFinite(Number(input.min)) ? Number(input.min) : 1;
    const maxValue = Number(input.max);
    const max = Number.isFinite(maxValue) && maxValue > 0 ? maxValue : 999;
    const current = Number(input.value);
    const value = Number.isFinite(current) ? current : min;
    const nextValue = button.matches('[data-quantity-plus]') ? Math.min(max, value + 1) : Math.max(min, value - 1);
    input.value = String(nextValue);
    mobileHaptic();
    if (cartControl) updateCartPageLine(cartControl, nextValue);
    else {
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  if (cartPage) {
    qsa('[data-cart-quantity-input]', cartPage).forEach(input => input.addEventListener('change', () => {
      const control = input.closest('[data-cart-quantity-control]');
      const min = Number.isFinite(Number(input.min)) ? Number(input.min) : 1;
      const maxValue = Number(input.max);
      const max = Number.isFinite(maxValue) && maxValue > 0 ? maxValue : 999;
      const entered = Number(input.value);
      const quantity = Math.min(max, Math.max(min, Number.isFinite(entered) ? Math.floor(entered) : min));
      input.value = String(quantity);
      updateCartPageLine(control, quantity);
    }));
  }

  qsa('[data-product-tab]').forEach(tab => tab.addEventListener('click', () => {
    const target = tab.dataset.productTab;
    qsa('[data-product-tab]').forEach(item => item.classList.toggle('is-active', item === tab));
    qsa('[data-product-panel]').forEach(panel => panel.classList.toggle('is-active', panel.dataset.productPanel === target));
  }));

  const playDiscountPopupChime = () => {
    try {
      const AudioContextClass = window.AudioContext || window.webkitAudioContext;
      if (!AudioContextClass) return;
      const audioContext = new AudioContextClass();
      const startTone = () => {
        const startAt = audioContext.currentTime;
        const master = audioContext.createGain();
        master.gain.setValueAtTime(0.0001, startAt);
        master.gain.exponentialRampToValueAtTime(0.085, startAt + 0.018);
        master.gain.exponentialRampToValueAtTime(0.0001, startAt + 0.34);
        master.connect(audioContext.destination);
        [[784, 0], [1046, 0.09]].forEach(([frequency, offset]) => {
          const oscillator = audioContext.createOscillator();
          oscillator.type = 'sine';
          oscillator.frequency.setValueAtTime(frequency, startAt + offset);
          oscillator.connect(master);
          oscillator.start(startAt + offset);
          oscillator.stop(startAt + offset + 0.22);
        });
        window.setTimeout(() => audioContext.close?.(), 600);
      };
      if (audioContext.state === 'suspended') audioContext.resume().then(startTone).catch(() => {});
      else startTone();
    } catch (error) {}
  };

  const celebrateDiscountUnlock = () => {
    if (!document.body || qs('[data-discount-celebration]')) return;
    const celebration = document.createElement('div');
    celebration.className = 'discount-celebration';
    celebration.dataset.discountCelebration = '';
    celebration.setAttribute('role', 'status');
    celebration.setAttribute('aria-live', 'polite');
    celebration.innerHTML = '<div class="discount-celebration__glow" aria-hidden="true"></div><div class="discount-celebration__message"><span class="discount-celebration__eyebrow">Gift unlocked</span><strong>Congratulations! Your discount is unlocked</strong><small>Use your coupon code below.</small></div><div class="discount-celebration__particles" aria-hidden="true">' + Array.from({ length: 24 }, (_, index) => `<i style="--x:${(index * 37) % 100}%;--y:${20 + ((index * 23) % 62)}%;--r:${(index * 29) % 360}deg;--d:${(index % 6) * .08}s;--c:${index % 3}"></i>`).join('') + '</div>';
    document.body.appendChild(celebration);
    requestAnimationFrame(() => celebration.classList.add('is-active'));
    window.setTimeout(() => celebration.classList.remove('is-active'), 2850);
    window.setTimeout(() => celebration.remove(), 3500);
  };

  /* Swipe-to-reveal discount offer. The code is only revealed in the UI; Shopify applies it after Admin setup. */
  qsa('[data-discount-offer]').forEach(offer => {
    const track = qs('[data-discount-track]', offer);
    const knob = qs('[data-discount-knob]', offer);
    const fill = qs('[data-discount-fill]', offer);
    const reveal = qs('[data-discount-reveal]', offer);
    const applyButton = qs('[data-discount-apply]', offer);
    const status = qs('[data-discount-status]', offer);
    const productPage = qs('[data-product-page]');
    const productIdentity = productPage?.dataset.productId || location.pathname;
    const appliedDiscountPersistKey = `pakplus-discount-applied-v4-${productIdentity}`;
    const discountReturnKey = `pakplus-discount-return-v4-${productIdentity}`;
    const discountTimerKey = 'lehray-extra-discount-deadline-v1';
    const discountActiveCodeKey = 'lehray-extra-discount-code-v1';
    const discountActiveProductKey = 'lehray-extra-discount-product-v1';
    const discountDurationMs = 46 * 60 * 1000;
    if (!track || !knob || !fill || !reveal) return;
    let startX = 0;
    let dragging = false;
    let unlocked = false;
    const positionCompletedSwipe = () => {
      const completedDistance = Math.max(1, track.clientWidth - knob.offsetWidth - 8);
      knob.style.transform = `translateX(${completedDistance}px)`;
      fill.style.width = '100%';
    };
    const markDiscountApplied = () => {
      if (!applyButton) return;
      applyButton.disabled = true;
      applyButton.textContent = 'Discount applied.';
      applyButton.setAttribute('aria-disabled', 'true');
    };
    const showAppliedSummary = () => {
      const unlockedContent = qs('[data-discount-unlocked-content]', offer);
      const appliedSummary = qs('[data-discount-applied-summary]', offer);
      if (unlockedContent) unlockedContent.hidden = true;
      if (appliedSummary) appliedSummary.hidden = false;
      offer.classList.add('discount-applied');
    };
    const readDiscountDeadline = () => {
      try {
        const stored = Number(localStorage.getItem(discountTimerKey) || 0);
        return Number.isFinite(stored) && stored > 0 ? stored : 0;
      } catch (error) { return 0; }
    };
    const writeDiscountDeadline = deadline => {
      try { localStorage.setItem(discountTimerKey, String(deadline)); } catch (error) {}
    };
    const clearDiscountDeadline = () => {
      try {
        localStorage.removeItem(discountTimerKey);
        localStorage.removeItem(discountActiveCodeKey);
        localStorage.removeItem(discountActiveProductKey);
      } catch (error) {}
    };
    const updateAppliedTimer = () => {
      const timerEl = qs('[data-discount-timer]', offer);
      const deadline = readDiscountDeadline();
      if (!timerEl || !deadline) return false;
      const remaining = Math.max(0, deadline - Date.now());
      const totalSeconds = Math.ceil(remaining / 1000);
      timerEl.textContent = `${String(Math.floor(totalSeconds / 60)).padStart(2, '0')}:${String(totalSeconds % 60).padStart(2, '0')}`;
      if (!remaining) {
        clearDiscountDeadline();
        timerEl.textContent = '00:00';
        return false;
      }
      return true;
    };
    let discountTimerInterval = null;
    const startAppliedTimer = () => {
      if (discountTimerInterval) window.clearInterval(discountTimerInterval);
      if (!updateAppliedTimer()) return;
      discountTimerInterval = window.setInterval(() => {
        if (!updateAppliedTimer()) {
          window.clearInterval(discountTimerInterval);
          discountTimerInterval = null;
        }
      }, 1000);
    };
    const showDiscountPreview = () => {
      const priceEl = qs('[data-product-price]');
      const discountedPriceEl = qs('[data-discounted-price]');
      const baseCents = Number(priceEl?.dataset.priceCents || 0);
      const percent = Math.max(0, Math.min(90, Number(offer.dataset.discountPercent || 0)));
      const discountedCents = Math.max(0, Math.round(baseCents * (100 - percent) / 100));
      if (discountedPriceEl) {
        discountedPriceEl.textContent = money(discountedCents);
        discountedPriceEl.hidden = false;
      }
      if (priceEl) priceEl.classList.add('is-discount-applied');
      offer.classList.add('discount-applied');
      try {
        const currentDeadline = readDiscountDeadline();
        if (!currentDeadline || currentDeadline <= Date.now()) writeDiscountDeadline(Date.now() + discountDurationMs);
      } catch (error) {}
      showAppliedSummary();
      startAppliedTimer();
      document.dispatchEvent(new CustomEvent('pakplus:discount-applied'));
      if (status) status.textContent = 'Discount applied.';
      markDiscountApplied();
    };
    const revealDiscount = () => {
      if (unlocked) return;
      unlocked = true;
      dragging = false;
      offer.classList.add('is-revealed');
      track.setAttribute('aria-expanded', 'true');
      positionCompletedSwipe();
      reveal.hidden = false;
      celebrateDiscountUnlock();
      mobileHaptic();
    };
    const updateSwipe = clientX => {
      if (!dragging || unlocked) return;
      const distance = Math.max(0, clientX - startX);
      const available = Math.max(1, track.clientWidth - knob.offsetWidth - 8);
      const progress = Math.min(1, distance / available);
      knob.style.transform = `translateX(${progress * available}px)`;
      fill.style.width = `${Math.max(0, progress * 100)}%`;
      if (progress >= .82) revealDiscount();
    };
    track.addEventListener('pointerdown', event => { if (unlocked) return; dragging = true; startX = event.clientX; track.setPointerCapture?.(event.pointerId); });
    track.addEventListener('pointermove', event => updateSwipe(event.clientX));
    track.addEventListener('pointerup', () => { if (!unlocked) { dragging = false; knob.style.transform = ''; fill.style.width = ''; } });
    track.addEventListener('pointercancel', () => { dragging = false; if (!unlocked) { knob.style.transform = ''; fill.style.width = ''; } });
    window.setTimeout(() => { offer.classList.add('is-visible'); if (unlocked) positionCompletedSwipe(); playDiscountPopupChime(); }, 2000);
    if (applyButton) applyButton.addEventListener('click', () => {
      const code = (offer.dataset.discountCode || '').trim();
      if (!code || applyButton.disabled) return;
      const currentProductId = String(offer.dataset.discountProductId || productPage?.dataset.productId || '');
      applyButton.disabled = true;
      applyButton.textContent = 'Applying…';
      if (status) status.textContent = 'Applying your extra discount…';
      showDiscountPreview();
      try {
        localStorage.setItem(appliedDiscountPersistKey, code);
        localStorage.setItem(discountActiveCodeKey, code);
        localStorage.setItem(discountActiveProductKey, currentProductId);
      } catch (error) {}
      const returnUrl = new URL(location.href);
      returnUrl.searchParams.set('discount_applied', '1');
      try { sessionStorage.setItem(discountReturnKey, code); } catch (error) {}
      const redirectPath = `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`;
      const discountUrl = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirectPath)}`;
      const returnHref = returnUrl.href;
      const applyDiscountWithoutLeavingPreview = async () => {
        try {
          const response = await fetch(discountUrl, { credentials: 'same-origin', redirect: 'follow', cache: 'no-store' });
          if (!response.ok) throw new Error(`Discount request failed with ${response.status}`);
          window.location.assign(returnHref);
        } catch (error) {
          /* Keep the original Shopify fallback for browsers that block fetch redirects. */
          window.location.assign(discountUrl);
        }
      };
      window.setTimeout(applyDiscountWithoutLeavingPreview, 260);
    });
    let returnedWithDiscount = new URLSearchParams(location.search).get('discount_applied') === '1';
    try {
      const activeCode = (offer.dataset.discountCode || '').trim();
      const storedDeadline = readDiscountDeadline();
      const storedCode = localStorage.getItem(appliedDiscountPersistKey);
      const activeStoredCode = localStorage.getItem(discountActiveCodeKey);
      const activeStoredProduct = localStorage.getItem(discountActiveProductKey);
      const currentProductId = String(offer.dataset.discountProductId || productPage?.dataset.productId || '');
      const sessionCode = sessionStorage.getItem(discountReturnKey);
      const productScopeMatches = !activeStoredProduct || activeStoredProduct === currentProductId;
      returnedWithDiscount = returnedWithDiscount || (storedDeadline > Date.now() && productScopeMatches && (sessionCode === activeCode || storedCode === activeCode || activeStoredCode === activeCode));
    } catch (error) {}
    if (returnedWithDiscount) {
      unlocked = true;
      reveal.hidden = false;
      offer.classList.add('is-revealed');
      track.setAttribute('aria-expanded', 'true');
      positionCompletedSwipe();
      window.requestAnimationFrame?.(() => window.requestAnimationFrame?.(positionCompletedSwipe));
      window.setTimeout(positionCompletedSwipe, 80);
      if (!readDiscountDeadline()) writeDiscountDeadline(Date.now() + discountDurationMs);
      showDiscountPreview();
      showAppliedSummary();
      startAppliedTimer();
      const cleanUrl = new URL(location.href);
      cleanUrl.searchParams.delete('discount_applied');
      try { sessionStorage.removeItem(discountReturnKey); } catch (error) {}
      window.history.replaceState({}, document.title, `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`);
    }
  });

  const productJsonEl = qs('[data-product-json]');
  let productData = null;
  try { productData = productJsonEl ? JSON.parse(productJsonEl.textContent) : null; } catch (error) { productData = null; }
  const productForm = qs('[data-product-purchase-form]');
  if (productForm) {
    let selectedOptions = productData && productData.variants && productData.variants[0] ? [...productData.variants[0].options] : [];
    const formatPrice = cents => money(cents);
    const syncBuyNowDiscountStrip = () => {
      const strip = qs('[data-buy-now-discount-strip]', productForm);
      const discountOffer = qs('[data-discount-offer]', productForm);
      if (strip) strip.hidden = !Boolean(discountOffer?.classList.contains('discount-applied'));
    };
    const updateDisplayedPrices = () => {
      const quantityInput = qs('[data-quantity-input]', productForm);
      const min = Number.isFinite(Number(quantityInput?.min)) ? Number(quantityInput.min) : 1;
      const maxValue = Number(quantityInput?.max);
      const max = Number.isFinite(maxValue) && maxValue > 0 ? maxValue : 999;
      const entered = Number(quantityInput?.value);
      const quantity = Math.min(max, Math.max(min, Number.isFinite(entered) && entered > 0 ? Math.floor(entered) : min));
      if (quantityInput && String(quantityInput.value) !== String(quantity)) quantityInput.value = String(quantity);

      const priceEl = qs('[data-product-price]');
      const compareEl = qs('[data-product-compare]');
      const discountEl = qs('[data-product-discount]');
      const discountedPriceEl = qs('[data-discounted-price]');
      const priceRow = priceEl?.closest('.product-price-row');
      const unitCents = Number(priceEl?.dataset.priceCents || 0);
      const compareCents = Number(compareEl?.dataset.compareCents || 0);
      const hasBaseSale = compareCents > unitCents && compareCents > 0;
      const discountOffer = qs('[data-discount-offer]', productForm);
      const discountApplied = Boolean(discountOffer?.classList.contains('discount-applied'));
      const extraPercent = Math.max(0, Math.min(90, Number(discountOffer?.dataset.discountPercent || 0)));
      const baseTotal = Math.max(0, unitCents * quantity);
      const finalTotal = Math.max(0, Math.round(baseTotal * (100 - extraPercent) / 100));
      const referenceCents = hasBaseSale ? compareCents : unitCents;
      const effectiveCents = discountApplied ? Math.round(unitCents * (100 - extraPercent) / 100) : unitCents;
      const totalPercent = referenceCents > effectiveCents ? Math.round((referenceCents - effectiveCents) * 100 / referenceCents) : 0;

      if (priceRow) priceRow.classList.toggle('has-applied-discount', discountApplied);
      if (priceEl) {
        priceEl.textContent = formatPrice(baseTotal);
        priceEl.classList.toggle('is-discount-applied', discountApplied);
        priceEl.classList.toggle('is-hidden', discountApplied);
      }
      if (discountedPriceEl) {
        if (discountApplied) {
          discountedPriceEl.textContent = formatPrice(finalTotal);
          discountedPriceEl.hidden = false;
        } else {
          discountedPriceEl.textContent = '';
          discountedPriceEl.hidden = true;
        }
      }
      if (compareEl) {
        const comparisonCents = discountApplied ? (hasBaseSale ? compareCents : unitCents) : compareCents;
        const showComparison = comparisonCents > 0 && (discountApplied || hasBaseSale);
        if (showComparison) {
          compareEl.textContent = formatPrice(comparisonCents * quantity);
          compareEl.classList.remove('is-hidden');
        } else {
          compareEl.textContent = '';
          compareEl.classList.add('is-hidden');
        }
      }
      if (discountEl) {
        const showDiscount = discountApplied ? extraPercent > 0 : hasBaseSale;
        discountEl.textContent = showDiscount ? (discountApplied ? `Extra ${extraPercent}% OFF applied` : `${totalPercent}% OFF`) : '';
        discountEl.classList.toggle('is-hidden', !showDiscount);
      }
    };
    document.addEventListener('pakplus:discount-applied', updateDisplayedPrices);
    document.addEventListener('pakplus:discount-applied', syncBuyNowDiscountStrip);
    const setProductState = variant => {
      if (!variant) return;
      const idInput = qs('[data-variant-id]', productForm); if (idInput) idInput.value = variant.id;
      const priceEl = qs('[data-product-price]'); if (priceEl) { priceEl.dataset.priceCents = variant.price; }

      const compareEl = qs('[data-product-compare]'); const discountEl = qs('[data-product-discount]');
      if (compareEl) compareEl.dataset.compareCents = String(Number(variant.compare_at_price || 0));
      if (compareEl && variant.compare_at_price > variant.price) { compareEl.textContent = formatPrice(variant.compare_at_price); compareEl.classList.remove('is-hidden'); }
      else if (compareEl) { compareEl.textContent = ''; compareEl.classList.add('is-hidden'); }
      if (discountEl && variant.compare_at_price > variant.price) { discountEl.textContent = `${Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)}% OFF`; discountEl.classList.remove('is-hidden'); }
      else if (discountEl) { discountEl.textContent = ''; discountEl.classList.add('is-hidden'); }
      syncBuyNowDiscountStrip();
      const addButton = qs('[data-product-add]', productForm); const buyButton = qs('[data-buy-now]', productForm);
      [addButton, buyButton].forEach(button => { if (button) button.disabled = !variant.available; });
      if (addButton) { const span = qs('span', addButton); if (span) span.textContent = variant.available ? 'Add to Cart' : 'Sold Out'; }
      const quantity = qs('[data-quantity-input]', productForm);
      if (quantity) {
        if (variant.inventory_management && Number(variant.inventory_quantity) > 0) quantity.max = String(variant.inventory_quantity);
        else quantity.removeAttribute('max');
        const max = Number(quantity.max);
        if (Number.isFinite(max) && max > 0 && Number(quantity.value) > max) quantity.value = String(max);
      }
      updateDisplayedPrices();
      if (variant.featured_media && variant.featured_media.id) { const thumb = qs(`[data-media-thumb="${variant.featured_media.id}"]`); if (thumb) thumb.click(); }
    };
    qsa('[data-option-value]', productForm).forEach(optionButton => optionButton.addEventListener('click', () => {
      const position = parseInt(optionButton.dataset.optionPosition, 10) - 1;
      selectedOptions[position] = optionButton.dataset.optionValue;
      qsa(`[data-option-position="${optionButton.dataset.optionPosition}"]`, productForm).forEach(item => item.classList.toggle('is-selected', item === optionButton));
      const label = qs(`[data-selected-option="${optionButton.dataset.optionPosition}"]`, productForm); if (label) label.textContent = optionButton.dataset.optionValue;
      const variant = productData && productData.variants ? productData.variants.find(item => item.options.every((value, index) => value === selectedOptions[index])) : null;
      setProductState(variant);
    }));
    const submitProduct = async (event, buyNow = false) => {
      event.preventDefault();
      const quantityInput = qs('[data-quantity-input]', productForm);
      if (quantityInput) {
        const min = Number.isFinite(Number(quantityInput.min)) ? Number(quantityInput.min) : 1;
        const maxValue = Number(quantityInput.max);
        const max = Number.isFinite(maxValue) && maxValue > 0 ? maxValue : 999;
        const entered = Number(quantityInput.value);
        quantityInput.value = String(Math.min(max, Math.max(min, Number.isFinite(entered) ? Math.floor(entered) : min)));
      }
      const button = buyNow ? qs('[data-buy-now]', productForm) : qs('[data-product-add]', productForm);
      const originalMarkup = button ? button.innerHTML : '';
      if (button) {
        button.dataset.defaultMarkup = originalMarkup;
        button.dataset.processing = buyNow ? 'true' : 'false';
        button.disabled = true;
        button.textContent = buyNow ? 'Processing…' : 'Adding…';
      }
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(productForm) });
        if (!response.ok) throw new Error('Unable to add product');
        if (buyNow) {
          window.location.href = '/checkout';
        } else {
          if (button) {
            button.classList.add('is-cart-adding');
            button.setAttribute('aria-busy', 'true');
            button.innerHTML = '<span class="add-to-cart-status-icon" aria-hidden="true">✓</span><span>Added to cart</span>';
          }
          if (cartCount) {
            cartCount.classList.remove('cart-count-pop');
            void cartCount.offsetWidth;
            cartCount.classList.add('cart-count-pop');
          }
          mobileHaptic();
          window.setTimeout(() => {
            if (button) {
              button.classList.remove('is-cart-adding');
              button.removeAttribute('aria-busy');
              button.disabled = false;
              button.dataset.processing = 'false';
              button.innerHTML = originalMarkup;
            }
            openCart();
          }, 520);
        }
      } catch (error) {
        if (button) { button.disabled = false; button.dataset.processing = 'false'; button.innerHTML = originalMarkup; }
        window.location.href = '/cart';
      }
    };
    const restorePendingBuyNow = () => qsa('[data-buy-now]').forEach(button => { if (button.dataset.processing === 'true') { button.innerHTML = button.dataset.defaultMarkup || button.innerHTML; button.disabled = false; button.dataset.processing = 'false'; } });
    window.addEventListener('pageshow', restorePendingBuyNow);
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') restorePendingBuyNow(); });
    productForm.addEventListener('submit', event => submitProduct(event, false));
    const quantityInput = qs('[data-quantity-input]', productForm);
    quantityInput?.addEventListener('input', updateDisplayedPrices);
    quantityInput?.addEventListener('change', updateDisplayedPrices);
    const initialVariant = productData && productData.variants ? productData.variants.find(item => item.options.every((value, index) => value === selectedOptions[index])) : null;
    if (initialVariant) setProductState(initialVariant);
    const buyNow = qs('[data-buy-now]', productForm); if (buyNow) buyNow.addEventListener('click', event => { if (window.matchMedia && window.matchMedia('(max-width: 800px)').matches && typeof navigator.vibrate === 'function') navigator.vibrate(18); submitProduct(event, true); });
  }

  /* Reliable Categories dropdown */
  qsa('[data-category-dropdown]').forEach(dropdown => {
    const summary = qs('[data-category-summary]', dropdown);
    if (!summary) return;
    summary.addEventListener('click', event => {
      event.preventDefault();
      qsa('[data-category-dropdown]').forEach(other => { if (other !== dropdown) other.removeAttribute('open'); });
      dropdown.toggleAttribute('open');
    });
    summary.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); summary.click(); } });
  });
  document.addEventListener('click', event => { if (!event.target.closest('[data-category-dropdown]')) qsa('[data-category-dropdown]').forEach(dropdown => dropdown.removeAttribute('open')); });
})();
